module.exports = __webpack_public_path__ + "img/soup.43c9858b.svg";